import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DonationInfo } from "./donation";

export const Checkout = "checkout";
export type Checkout = typeof Checkout;

export const CreateCheckout = `${Checkout}/createCheckout`;
export type CreateCheckout = typeof CreateCheckout;

export type CheckoutInfo = {
    checkoutId: string | null,
}

export enum CheckoutStatus {
    none,
    createInProgress,
    createSuccess,
    createError,
    checkoutComplete,
}

export interface CheckoutState {
    data: {
        checkoutId: string | null,
        donationInfo: DonationInfo
    },
    checkoutStatus: CheckoutStatus | null,
    error: string | null
}

const initialState: CheckoutState = {
    data: {
        donationInfo: { donationAmount: 0 },
        checkoutId: null,
    },
    checkoutStatus: CheckoutStatus.none,
    error: null
}

const checkoutSlice = createSlice({
    name: Checkout,
    initialState,
    reducers: {
        resetCheckoutState: (state: CheckoutState) => {
            state = {...initialState};
            return state;
        },
        createCheckout: (state: CheckoutState, action: PayloadAction<DonationInfo>) => {
            state.data.donationInfo = action.payload;
            state.checkoutStatus = CheckoutStatus.createInProgress;
            state.error = null;
            return state;
        },
        createCheckoutSuccess: (state: CheckoutState, action: PayloadAction<string>) => {
            state.data.checkoutId = action.payload;
            state.checkoutStatus = CheckoutStatus.createSuccess;
            state.error = null;
            return state;
        },
        createCheckoutError: (state: CheckoutState, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.checkoutStatus = CheckoutStatus.createError;
            return state;
        },
        checkoutComplete: (state: CheckoutState) => {
            state.error = null;
            state.checkoutStatus = CheckoutStatus.checkoutComplete;
            state.data.donationInfo =  { donationAmount: 0 };
            state.data.checkoutId = null;
            return state;
        }
    }
});

export default checkoutSlice.reducer;
export const { resetCheckoutState, createCheckout, createCheckoutSuccess, createCheckoutError, checkoutComplete } = checkoutSlice.actions;
